import { Component } from '@angular/core';

@Component({
  selector: 'cbs-liability-loan-operations',
  template: '<router-outlet></router-outlet>'
})

export class BondOperationsWrapComponent {
}
